import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

import { User } from '../../models/user';
import { UsersService } from '../../services/users.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LoaderComponent } from '../loader/loader.component';
import { AuthCodeFormComponentUser } from '../auth-code-form-user/auth-code-form-user.component';
import { InlineOtpComponent } from '../inline-otp/inline-otp.component';
import { UserOtp } from '../../models/UserOtp';
import { EmailCode } from '../../models/EmailCode';
import { UserInfoModalComponent } from '../user-info-modal/user-info-modal.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { LoginUserModel } from '../../models/loginUserModel';
import { environment } from '../../../environments/environment';


@Component({
    selector: 'app-user-modal',
    imports: [
        
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        CommonModule,
        LoaderComponent,
        InlineOtpComponent,
        UserInfoModalComponent,
        DialogModule,
        ButtonModule,
        InputTextModule,
        TooltipModule,
        SelectModule,
    ],
    templateUrl: './user-modal.component.html',
    styleUrl: './user-modal.component.scss',
    providers: [provideNgxMask()]
})
export class UserModalComponent {
  @Input() message!: string;
  @Input() inProcess!: boolean;
  @Input() userData!: any;
  @Input() isNewUser!: boolean;
  @Input() elements: any[] = [];
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Output() showModalAlert: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() msgModalAlert: EventEmitter<string> = new EventEmitter<string>();
  @Input() txtCancelButton: string = 'Cancelar';
  @Input() txtConfirmButton: string = 'Guardar';
  accessType: number = 0;
  formProfile!: FormGroup;
  user: User = new User();
  msgError: string[] = [];
  msgResponse = '';
  isLoader: boolean = false;
  selectedLada = '+52';
  showLadaList = false;
  show2FA = false;
  visible = true;
  showInlineEmailOtp = false;
  sendingOtp = false;
  sendingEmailOtp = false;
  sendingPhoneOtp = false;
  saving = false;
  showInlinePhoneOtp = false;
  IsPhone = false;
  isButtonEmail: boolean = false;
  isButtonOTP: boolean = false;
  showModal = false;
  originalPhone: string = '';
  originalEmail: string = '';
  data!: LoginUserModel;

  pattern = {
    K: {
      pattern: new RegExp('[^\\s]'),
      optional: true,
    },
  };
  constructor(
    private service: UsersService,
    @Inject(DOCUMENT) public document: Document
  ) {
    this.data = JSON.parse(localStorage.getItem('data')!);
    this.formProfile = new FormGroup({
      name: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      phone: new FormControl({ value: '', disabled: false }, [
        Validators.required,
        this.validateUniquePhone(0),
      ]),
      email: new FormControl({ value: '', disabled: false }, [
        Validators.required,
        Validators.email,
        this.validateUniqueEmail(0),
      ]),
      position: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
    });
  }
  ngOnInit(): void {
    this.msgError = [];
    if (this.userData.userId > 0) {

      const phone =
        this.userData.phone == '' ? '' : this.userData.phone.split(' ')[1];
      this.formProfile.get('name')?.setValue(this.userData.name);
      this.formProfile.get('phone')?.setValue(phone);
      this.formProfile
        .get('phone')
        ?.setValidators([
          Validators.required,
          this.validateUniquePhone(this.userData.userId),
        ]);
      this.formProfile.get('email')?.setValue(this.userData.email);
      this.formProfile
        .get('email')
        ?.setValidators([
          Validators.required,
          Validators.email,
          this.validateUniqueEmail(this.userData.userId),
        ]);
      this.formProfile.get('position')?.setValue(this.userData.position);
      this.accessType = this.GetUserType(this.userData.accessType);
      this.selectedLada =
        this.userData.phone == ''
          ? this.selectedLada
          : this.userData.phone.split(' ')[0];
      this.originalPhone = phone;
      this.originalEmail = this.userData.email;
      this.phone.disable();
      this.email.disable();
      if (this.userData.email != '') {
        this.isButtonEmail = true;
      }

      if (this.userData.phone != '') {
        this.isButtonOTP = true;
      }
    }
  }

  get email() {
    return this.formProfile.get('email') as FormControl;
  }

  get phone() {
    return this.formProfile.get('phone') as FormControl;
  }

  cancelAction() {
    this.onCancel.emit();
  }

  clickOutside(isOut: any) {
    if (isOut) {
      this.showLadaList = false;
    }
  }

  confirmAction() {
    if (this.formProfile.valid && this.isButtonEmail && this.isButtonOTP) {
      this.user.clientNumber = this.userData.clientNumber;
      this.user.userId = this.userData.userId;
      this.user.name = this.formProfile.get('name')?.value;
      this.user.phone = this.formProfile.get('phone')?.value;
      this.user.email = this.formProfile.get('email')?.value;
      this.user.position = this.formProfile.get('position')?.value;
      this.user.accessType = this.accessType;
      this.user.dialCode = +this.selectedLada.split('+')[1];
      if (this.user.userId > 0) {
        this.updateUser(this.user);
      } else {
        this.addUser(this.user);
      }
    } else if (!this.formProfile.valid) {
      this.msgError[0] = 'Favor de llenar los campos obligatorios';
    } else if (!this.isButtonEmail) {
      this.msgError[0] =
        'Favor de autentificar el correo electrónico en el boton con el icono ▶';
    } else if (!this.isButtonOTP) {
      this.msgError[0] =
        'Favor de autentificar el teléfono en el boton con el icono ▶';
    }
  }

  updateUser(user: User) {
    this.msgResponse = '';
    this.saving = true;
    this.service.updateUser(user).subscribe({
      next: (data: any) => {
        this.saving = false;
        if (data.response == 'True') {
          this.onConfirm.emit();
          this.msgModalAlert.emit('Se guardó usuario correctamente');
        } else if (data.response == 'False') {
          this.msgResponse = 'Error al guardar, vuelva a intentarlo';
        } else {
          this.msgResponse = data.error[0];
        }
      },
      error: (err: any) => {
        this.saving = false;
        this.msgResponse = err;
      },
    });
  }

  addUser(user: User) {
    this.msgResponse = '';
    this.saving = true;
    this.service.addUser(user).subscribe({
      next: (data: any) => {
        this.saving = false;
        if (data.isSuccess) {
          this.onConfirm.emit();
          this.msgModalAlert.emit(data.message);
        } else {
          this.msgResponse = data.message;
        }
      },
      error: (err: any) => {
        this.saving = false;
        this.msgResponse = err.error?.error || err.error?.message || 'Error al crear usuario';
      },
    });
  }

  accessTypeOptions = [
    { value: 0, label: 'Consulta' },
    { value: 1, label: 'Modificación' },
    { value: 2, label: 'Revisión' },
    { value: 3, label: 'Finanzas' },
  ];

  onUserTypeChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.accessType = +selectElement.value;
  }

  onUserTypeChangeFromSelect(event: any): void {
    this.accessType = event.value;
  }

  GetUserType(accessType: string): number {
    if (accessType == 'Consulta') {
      return 0;
    }
    if (accessType == 'Revisión') {
      return 2;
    }
    if (accessType == 'Modificación') {
      return 1;
    } else accessType == 'Finanzas';
    {
      return 3;
    }
  }

  onEmailBlur() {
    if (this.email.valid && !this.isButtonEmail && !this.showInlineEmailOtp && this.email.value !== this.originalEmail) {
      this.validateSendMailOTP();
    }
  }

  onPhoneBlur() {
    if (this.phone.valid && !this.isButtonOTP && !this.showInlinePhoneOtp && this.phone.value !== this.originalPhone) {
      this.validateSendOTPCode();
    }
  }

  validateSendMailOTP() {
   
      if (this.email.valid) {
        let emailCode = new EmailCode();
        emailCode.email = this.formProfile.get('email')?.value;
        emailCode.clientNumber = this.data.Client_number;
        this.msgResponse = '';
        this.saveEmailOTP(emailCode);
      } else {
        this.msgError[0] = 'Correo electrónico no valido';
      }
    


  }

  toggleLadaList() {
    this.showLadaList = !this.showLadaList;
  }

  selectLada(lada: string) {
    this.selectedLada = lada.split(' ')[0];
    this.showLadaList = false;
  }

  validateOTP(code: any) {
    if (this.IsPhone) {
      this.validateOTPCode(code);
    } else {
      this.validateEmailCode(code);
    }
  }

  validateSendOTPCode() {
    
      if (this.phone.valid) {
        let userOtp = new UserOtp();
        userOtp.dialCode = this.selectedLada.split('+')[1];
        userOtp.phoneNumber = this.formProfile.get('phone')?.value;
        userOtp.clientNumber = this.userData.clientNumber;
        this.msgResponse = ''
        this.sendOTPCode(userOtp);
      } else {
        this.msgResponse = 'Teléfono no valido';
      }
    


  }

  sendOTPCode(user: UserOtp) {
    this.sendingPhoneOtp = true;
    this.service.validatePhoneNumber(user.clientNumber, user.phoneNumber, 3, user.dialCode).subscribe({
      next: (data: any) => {
        this.sendingPhoneOtp = false;
        if (data.msg) {
          this.showInlinePhoneOtp = true;
        } else {
          this.msgResponse = 'Teléfono no válido';
        }
      },
      error: (err: any) => {
        this.sendingPhoneOtp = false;
        this.msgResponse = 'Teléfono no válido';
      },
    });
  }

  saveEmailOTP(email: EmailCode) {
    this.sendingEmailOtp = true;
    this.service.saveEmailOTP(email).subscribe({
      next: (data: any) => {
        this.sendingEmailOtp = false;
        if (data.isSuccess) {
          this.showInlineEmailOtp = true;
        } else {
          this.msgResponse = data.message;
        }
      },
      error: (err: any) => {
        this.sendingEmailOtp = false;
        this.msgResponse = err;
      },
    });
  }

  validateOTPCode(code: any) {
    this.show2FA = false;
    this.showInlinePhoneOtp = false;
    this.isButtonOTP = true;
    this.phone.disable();
  }

  validateEmailCode(code: any) {
    this.show2FA = false;
    this.showInlineEmailOtp = false;
    this.email.disable();
    this.isButtonEmail = true;
  }

  onInlineEmailVerified(code: string) {
    this.validateEmailCode(code);
  }

  onInlinePhoneVerified(code: string) {
    this.validateOTPCode(code);
  }

  onInlineEmailCancelled() {
    this.showInlineEmailOtp = false;
  }

  onInlinePhoneCancelled() {
    this.showInlinePhoneOtp = false;
  }

  onResendEmail() {
    let emailCode = new EmailCode();
    emailCode.email = this.formProfile.get('email')?.value;
    emailCode.clientNumber = this.data.Client_number;
    this.saveEmailOTP(emailCode);
  }

  onResendPhone() {
    let userOtp = new UserOtp();
    userOtp.dialCode = this.selectedLada.split('+')[1];
    userOtp.phoneNumber = this.formProfile.get('phone')?.value;
    userOtp.clientNumber = this.userData.clientNumber;
    this.sendOTPCode(userOtp);
  }

  validateUniqueEmail(userId: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;
      const userExist = this.elements.find(
        (user) => user.email === email && user.userId !== userId
      );
      this.isButtonEmail =
        Validators.email(new FormControl(email)) === null &&
        email === this.originalEmail &&
        email != '';
      return userExist ? { duplicate: true } : null;
    };
  }

  validateUniquePhone(userId: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phone = control.value;
      const isOriginalPhone = phone.length === 10;
      const userExist = this.elements.find(
        (user) => user.phone.split(' ')[1] === phone && user.userId !== userId
      );
      this.isButtonOTP = phone.length === 10 && phone === this.originalPhone;
      if (userExist) {
        return {
          duplicate: true,
        };
      }

      if (!isOriginalPhone) {
        return { invalidPhone: true };
      }

      return null;
    };
  }


}
